/* TODO: translate */

import { Labels } from '../../shared-components/global/labels.js';

Labels.set(
    'ui-autocomplete',
    'hint',
    'Naudokite rodyklių aukštyn ir žemyn klavišus peržiūrai, Enter klavišą pasirinkimui.'
);
Labels.set('ui-autocomplete', 'suggestions', 'Pasiūlymai');
Labels.set('ui-autocomplete', 'suggestionsFound', 'Rodomi pasiūlymai: ');
Labels.set('ui-autocomplete', 'noSuggestionsFound', 'Pasiūlymai nerodomi');
